// SupremeX Detailing — pitch prototype data (frontend only)

const A = '/brand';

export const HERO_IMAGE = `${A}/frozen-m3.jpg`;

export const TRUST = [
  'XPEL AUTHORIZED INSTALLER',
  '5.0 ★ · 200+ GOOGLE REVIEWS',
  'PPF · CERAMIC · TINT · WRAP',
  '865 CAMPBELL AVE · OTTAWA',
  '10-YEAR FILM WARRANTY',
  'CLIMATE-CONTROLLED STUDIO',
];

// Expanding Protection System panels (service accents as supporting colours)
export const PROTECTION = [
  { key: 'ppf', tag: 'Paint protection film', color: 'var(--c-ppf)', title: 'PPF', line: 'Invisible armour', body: 'XPEL ULTIMATE PLUS absorbs rock chips, salt and road debris — then heals itself in the sun.', image: `${A}/x3-ppf.jpg`, link: '/ppf' },
  { key: 'ceramic', tag: 'Ceramic coating', color: 'var(--c-ceramic)', title: 'Ceramic', line: 'Locked-in gloss', body: 'FUSION PLUS bonds to the clear coat for a slicker, deeper, easier-to-clean finish for years.', image: `${A}/gt3rs.jpg`, link: '/services/ceramic' },
  { key: 'tint', tag: 'Ceramic window tint', color: 'var(--c-tint)', title: 'Tint', line: 'Cooler cabin', body: 'PRIME XR PLUS rejects up to 98% of infrared heat and 99% of UV without a dark, blocky look.', image: `${A}/bmw-tint.jpg`, link: '/services/tint' },
  { key: 'wrap', tag: 'Colour-change wrap', color: 'var(--c-wrap)', title: 'Wrap', line: 'A new identity', body: 'Satin, matte, gloss or full stealth — change how the car reads without touching the paint.', image: `${A}/tesla-gold.jpg`, link: '/services/wrap' },
];

export const STUDIO_POINTS = [
  { n: '01', title: 'Purpose-built studio', meta: 'Ottawa' },
  { n: '02', title: 'Climate controlled', meta: 'Year-round' },
  { n: '03', title: 'Dust-free process', meta: 'Controlled' },
  { n: '04', title: 'XPEL authorized', meta: 'Certified' },
  { n: '05', title: 'Craft-first schedule', meta: 'Limited slots' },
];

export const GALLERY = [
  { src: `${A}/p1.jpg`, label: 'Ferrari 296 / PPF + ceramic', span: 'md:col-span-2 md:row-span-2' },
  { src: `${A}/tesla-gold.jpg`, label: 'Tesla Model Y / gold wrap', span: '' },
  { src: `${A}/gt3rs.jpg`, label: '911 GT3 RS / protection', span: '' },
  { src: `${A}/p7.jpg`, label: 'F-150 / paint correction', span: '' },
  { src: `${A}/p5.jpg`, label: 'Range Rover / ceramic', span: '' },
  { src: `${A}/p6.jpg`, label: 'Jaguar F-Type / satin wrap', span: 'md:col-span-2' },
  { src: `${A}/m3-white.jpg`, label: 'BMW M3 / full detail', span: '' },
];

export const REVIEWS = [
  { name: 'Axel Armani', car: 'Audi SQ5', text: 'Had my Audi ceramic coated here and I couldn\u2019t be happier. The gloss and depth after correction and coating is unreal.' },
  { name: 'Idrees Gurhan', car: 'Tesla Model Y', text: 'Full XPEL PPF, ceramic coating and window tint on my Model Y — results are incredible. Clean edges, full coverage, seamless.' },
  { name: 'Christopher Sullivan', car: 'Honda CR-V', text: 'Best detail job my CR-V has ever had. They pay attention to every detail and clean out every nook and cranny.' },
  { name: 'Yu Sui', car: 'BMW M3', text: 'Workmanship is outstanding — extremely detailed, precise and very clean. The PPF looks seamless and professionally finished.' },
];

// Home mini-configurator
export const CONFIG_VEHICLES = [
  { id: 'coupe', title: 'Coupe / Sedan', meta: 'M3 · C-Class · Model 3', mult: 1 },
  { id: 'suv', title: 'SUV / Truck', meta: 'G-Wagon · X5 · Model Y', mult: 1.18 },
  { id: 'exotic', title: 'Exotic', meta: 'Vantage · 911 · Urus', mult: 1.35 },
];

export const CONFIG_GOALS = [
  { id: 'protect', title: 'Protect it', body: 'Keep it factory-fresh', color: 'var(--c-ppf)', services: ['Full-front PPF', 'Ceramic coating', 'Ceramic tint'], base: 3600 },
  { id: 'refine', title: 'Refine it', body: 'Correct & seal the finish', color: 'var(--c-correction)', services: ['2-step correction', '8-year ceramic', 'Ceramic tint'], base: 2400 },
  { id: 'transform', title: 'Transform it', body: 'Change the whole look', color: 'var(--c-wrap)', services: ['Full colour wrap', 'Ceramic over film', 'Ceramic tint'], base: 5200 },
];

// PPF page
export const PPF_COVERAGE = [
  { id: 'partial', n: '01', title: 'Partial front', body: 'Entry protection for the highest-impact areas.', zones: ['frontBumper', 'hoodFront'] },
  { id: 'full-front', n: '02', title: 'Full front', body: 'Bumper, full hood, fenders, mirrors and lights.', zones: ['frontBumper', 'hoodFront', 'hood', 'fenderL', 'fenderR', 'mirrorL', 'mirrorR'] },
  { id: 'track', n: '03', title: 'Track package', body: 'Full front plus rockers, A-pillars and door cups.', zones: ['frontBumper', 'hoodFront', 'hood', 'fenderL', 'fenderR', 'mirrorL', 'mirrorR', 'rockerL', 'rockerR', 'roofFront'] },
  { id: 'full', n: '04', title: 'Full body', body: 'Maximum coverage — every painted panel protected.', zones: ['frontBumper', 'hoodFront', 'hood', 'fenderL', 'fenderR', 'mirrorL', 'mirrorR', 'rockerL', 'rockerR', 'roofFront', 'roof', 'doorL', 'doorR', 'quarterL', 'quarterR', 'rearBumper', 'trunk'] },
];

export const PPF_LAYERS = [
  { n: '01', title: 'Factory clear coat', body: 'The surface being protected.' },
  { n: '02', title: 'Adhesive layer', body: 'Optically clear bonding system.' },
  { n: '03', title: 'Urethane film', body: 'Flexible impact-absorbing protection layer.' },
  { n: '04', title: 'Self-healing top coat', body: 'Surface durability, gloss and easy maintenance.' },
];

export const PPF_PROCESS = [
  { n: '01', title: 'Vehicle inspection', body: 'Condition documented before work begins.' },
  { n: '02', title: 'Decontamination + prep', body: 'Clean surface, controlled environment.' },
  { n: '03', title: 'Precision film install', body: 'Panel alignment, edge control, finish.' },
  { n: '04', title: 'Set + quality check', body: 'Edges, alignment and finish reviewed.' },
  { n: '05', title: 'Handover', body: 'Care guidance and warranty information.' },
];

export const PPF_FAQ = [
  { q: 'Will PPF change the colour of my paint?', a: 'High-quality clear film is optically transparent and preserves the original appearance. A stealth or matte film intentionally changes gloss level.' },
  { q: 'Can PPF go over corrected paint?', a: 'Yes. Paint correction can be performed before installation when the finish has swirls, haze or light defects that should not be sealed beneath film.' },
  { q: 'Can I protect only the front of the vehicle?', a: 'Yes. Coverage can be tailored around the highest-impact zones or expanded to full-body protection depending on the vehicle and how it is used.' },
  { q: 'What happens after installation?', a: 'The film needs time to settle and cure. We provide specific aftercare guidance, wash timing and warranty information at delivery.' },
];

export const BUILDER = {
  vehicles: [
    { id: 'coupe', title: 'Coupe / Sedan', meta: 'M3 / C-Class / Model 3', mult: 1 },
    { id: 'suv', title: 'SUV / Truck', meta: 'G-Wagon / X5 / Model Y', mult: 1.18 },
    { id: 'exotic', title: 'Exotic / Supercar', meta: 'Vantage / 911 / Huracán', mult: 1.35 },
  ],
  groups: [
    {
      id: 'ppf', n: '02', title: 'Paint protection film', meta: 'XPEL ULTIMATE PLUS / STEALTH', color: 'var(--c-ppf)',
      options: [
        { id: 'none', title: 'None', body: 'Skip film for now', price: 0 },
        { id: 'partial', title: 'Partial front', body: 'Partial hood / fenders / bumper / mirrors', price: 1200 },
        { id: 'full-front', title: 'Full front', body: 'Full hood / fenders / bumper / mirrors / lights', price: 2400 },
        { id: 'track', title: 'Track package', body: 'Full front + rockers / A-pillars / door cups', price: 3400 },
        { id: 'full', title: 'Full body', body: 'Every painted panel', price: 6800 },
      ],
    },
    {
      id: 'tint', n: '03', title: 'Window tint', meta: 'XPEL PRIME XR / XR PLUS', color: 'var(--c-tint)',
      options: [
        { id: 'none', title: 'None', body: 'Keep factory glass', price: 0 },
        { id: 'xr', title: 'PRIME XR ceramic', body: 'Sides + rear / heat + UV rejection', price: 450 },
        { id: 'xr-plus', title: 'PRIME XR PLUS', body: 'Sides + rear / maximum IR rejection', price: 650 },
        { id: 'xr-ws', title: 'XR PLUS + windshield', body: 'Full glass incl. clear windshield film', price: 1050 },
      ],
    },
    {
      id: 'ceramic', n: '04', title: 'Ceramic coating', meta: 'XPEL FUSION PLUS', color: 'var(--c-ceramic)',
      options: [
        { id: 'none', title: 'None', body: 'Skip coating for now', price: 0 },
        { id: 'c2', title: 'FUSION PLUS / 2-year', body: 'Paint + wheel faces', price: 900 },
        { id: 'c4', title: 'FUSION PLUS / 4-year', body: 'Paint / wheels / glass / trim', price: 1500 },
        { id: 'c8', title: 'FUSION PLUS / 8-year', body: 'Full exterior + interior protection', price: 2300 },
      ],
    },
    {
      id: 'correction', n: '05', title: 'Paint correction', meta: 'Before film or coating', color: 'var(--c-correction)',
      options: [
        { id: 'none', title: 'None / new vehicle', body: 'Finish is already clean', price: 0 },
        { id: 'p1', title: '1-step enhancement', body: 'Light swirls removed / gloss restored', price: 550 },
        { id: 'p2', title: '2-step correction', body: 'Compound + polish / 80–90% defect removal', price: 1100 },
      ],
    },
  ],
};

export const SERVICES = {
  ceramic: {
    nav: 'Ceramic', accent: 'var(--c-ceramic)',
    eyebrow: 'Ceramic coating / XPEL FUSION PLUS',
    title: ['Gloss that', 'stays.'],
    intro: 'A ceramic coating bonds to the clear coat and becomes the surface — harder, slicker and chemically resistant. Water beads, dirt releases, and the finish reads deeper than the day it left the factory.',
    image: `${A}/aston.jpg`,
    alt: 'Aston Martin Vantage ceramic coated at SupremeX',
    stats: [['8 yr', 'Up to / warranty'], ['9H', 'Surface hardness'], ['Hydrophobic', 'Self-cleaning'], ['UV', 'Fade resistance']],
    points: [
      { n: '01', title: 'Correction first', body: 'A coating locks in whatever is beneath it. We correct the paint before sealing it.' },
      { n: '02', title: 'Panel-by-panel application', body: 'Applied under inspection lighting, levelled by hand, cured in a controlled bay.' },
      { n: '03', title: 'Easier ownership', body: 'Road grime, salt and bird droppings release with a rinse. Less contact, fewer swirls.' },
      { n: '04', title: 'Warranty registered', body: 'XPEL FUSION PLUS warranty registered to your VIN on delivery.' },
    ],
    tiersTitle: ['Three levels of', 'commitment.'],
    tiers: [
      { n: '01', title: '2-year', body: 'Paint + wheel faces / daily drivers' },
      { n: '02', title: '4-year', body: 'Paint / wheels / glass / trim' },
      { n: '03', title: '8-year', body: 'Full exterior + interior fabric & leather' },
      { n: '04', title: 'Over PPF', body: 'Coating applied on top of film for combined protection' },
    ],
    faq: [
      { q: 'Do I still need to wash the car?', a: 'Yes — but far less often and with far less effort. A coated surface releases dirt easily and dries without spotting.' },
      { q: 'Can I coat a car that already has PPF?', a: 'Absolutely. FUSION PLUS is formulated to bond to film and adds hydrophobic behaviour and gloss on top of it.' },
      { q: 'How long until I can drive it?', a: 'The coating is touch-dry at delivery. Avoid washing for seven days while it fully cures.' },
    ],
  },
  tint: {
    nav: 'Tint', accent: 'var(--c-tint)',
    eyebrow: 'Window tint / XPEL PRIME XR PLUS',
    title: ['Cooler cabin.', 'Clearer view.'],
    intro: 'Ceramic window film blocks up to 98% of infrared heat and 99% of UV without darkening your view or interfering with signals. Comfort you feel on the first July afternoon.',
    image: `${A}/bmw-tint.jpg`,
    alt: 'Tinted BMW at SupremeX Ottawa',
    stats: [['98%', 'IR heat rejection'], ['99%', 'UV blocked'], ['Lifetime', 'Warranty'], ['Legal', 'Ontario compliant options']],
    points: [
      { n: '01', title: 'Computer-cut patterns', body: 'Every piece is plotted to your exact glass. No blades on your car, no gaps at the edges.' },
      { n: '02', title: 'Ceramic, not dyed', body: 'Nano-ceramic film holds its colour for life — no purple fade, no bubbling.' },
      { n: '03', title: 'Signal-safe', body: 'Metal-free construction keeps GPS, phone, radio and toll transponders working.' },
      { n: '04', title: 'Clear windshield film', body: 'Nearly invisible 70–80% VLT film rejects heat on the largest piece of glass in the car.' },
    ],
    tiersTitle: ['Pick the shade,', 'keep the clarity.'],
    tiers: [
      { n: '01', title: 'PRIME XR', body: 'Ceramic / excellent heat rejection / value' },
      { n: '02', title: 'PRIME XR PLUS', body: 'Multi-layer nano-ceramic / maximum IR rejection' },
      { n: '03', title: 'Windshield', body: 'Clear film / 70–80% VLT / heat + UV' },
      { n: '04', title: 'Glass roof', body: 'Tesla and panoramic roofs / cabin comfort' },
    ],
    faq: [
      { q: 'What shade is legal in Ontario?', a: 'Front side windows must allow at least 70% light through. Rear sides and rear glass can go darker. We walk you through what looks right and stays compliant.' },
      { q: 'How long does tint take?', a: 'Most vehicles are same-day. Full glass including windshield is typically a full day.' },
      { q: 'When can I roll the windows down?', a: 'Wait three to five days while the film fully adheres. A slight haze during curing is normal and clears on its own.' },
    ],
  },
  wrap: {
    nav: 'Wrap', accent: 'var(--c-wrap)',
    eyebrow: 'Vinyl wrap / Colour change',
    title: ['Change the colour.', 'Keep the car.'],
    intro: 'Satin, matte, gloss, colour-flip or full stealth — a wrap changes how the car reads without touching the paint underneath. Fully reversible. Fully yours.',
    image: `${A}/tesla-gold.jpg`,
    alt: 'Gold wrapped Tesla at SupremeX',
    stats: [['Reversible', 'Paint preserved'], ['200+', 'Colours + finishes'], ['5 yr', 'Film durability'], ['Custom', 'Accents + liveries']],
    points: [
      { n: '01', title: 'Disassembly, not shortcuts', body: 'Handles, lights, badges and trim come off so edges wrap around, not up to.' },
      { n: '02', title: 'Premium film only', body: '3M 2080, Avery SW900, KPMF and Inozetek — cast films that conform and last.' },
      { n: '03', title: 'Stealth PPF option', body: 'Want satin over a gloss factory colour? XPEL STEALTH protects and transforms in one layer.' },
      { n: '04', title: 'Detail-level finish', body: 'Seams hidden, edges sealed, post-heated to lock the film in place.' },
    ],
    tiersTitle: ['From accents', 'to full identity.'],
    tiers: [
      { n: '01', title: 'Chrome delete', body: 'Trim / badges / window surrounds' },
      { n: '02', title: 'Roof + accents', body: 'Roof / mirrors / spoiler / hood' },
      { n: '03', title: 'Full colour change', body: 'Every visible panel / door jambs optional' },
      { n: '04', title: 'Stealth PPF', body: 'Satin finish + full paint protection' },
    ],
    faq: [
      { q: 'Will a wrap damage my paint?', a: 'No — on factory paint, quality cast vinyl protects it. Removal is clean when done properly. Repainted or damaged panels are assessed before we commit.' },
      { q: 'How long does a wrap last?', a: 'Five to seven years with normal care. Garage-kept cars often go longer.' },
      { q: 'Can I take it through a car wash?', a: 'Hand wash is best. Avoid brush washes and pressure at the edges. We provide care guidance at delivery.' },
    ],
  },
};

export const EV = {
  hero: ['Built for the', 'glass roof.'],
  intro: 'Electric vehicles arrive with soft paint, panoramic glass and a cabin that heats like a greenhouse. SupremeX protects Tesla, Rivian, Polestar and every EV in Ottawa with a sequence built around how they are actually made and driven.',
  image: `${A}/tesla-gold.jpg`,
  stats: [['98%', 'IR heat blocked / glass roof'], ['−4°C', 'Typical cabin temp drop'], ['+ Range', 'Less A/C draw in summer'], ['10 yr', 'XPEL film warranty']],
  problems: [
    { n: '01', title: 'Soft factory paint', body: 'Tesla and most EV paint chips and swirls faster than legacy makes. Full-front PPF is the single highest-value install on a new EV.', fix: 'XPEL ULTIMATE PLUS / full front' },
    { n: '02', title: 'Panoramic glass', body: 'A glass roof is beautiful until July. Clear ceramic film on the roof rejects heat without changing the view.', fix: 'PRIME XR PLUS / roof + sides' },
    { n: '03', title: 'Battery-hungry A/C', body: 'A cooler cabin means less compressor time — and real range you get back on hot days.', fix: 'Full glass ceramic tint' },
    { n: '04', title: 'Salt and slush', body: 'Ottawa winters are hard on any finish. A coating keeps salt from bonding and makes rinsing enough.', fix: 'FUSION PLUS / 4-year' },
  ],
  packages: [
    { n: '01', title: 'Delivery Day', body: 'Full-front PPF / PRIME XR sides + rear / 2-year coating', est: 'from $3,750' },
    { n: '02', title: 'Glass Roof', body: 'Full-front PPF / XR PLUS full glass + roof / 4-year coating', est: 'from $4,950' },
    { n: '03', title: 'Stealth Tesla', body: 'Full-body XPEL STEALTH satin / XR PLUS glass / coating over film', est: 'from $9,400' },
  ],
  review: { name: 'Idrees Gurhan', text: 'Full XPEL PPF, ceramic coating and window tint on my Tesla Model Y — results are incredible. Clean edges, full coverage, seamless on the body.' },
};
